import React from 'react'

import { Anchor } from '~components/Markdown'
import { FiChevronsRight } from 'react-icons/fi'

import style from './CTA.module.scss'

const CTA = ({
  to,
  children
}) => (
  <span className={style.cta}>
    <Anchor href={ to }>
      <FiChevronsRight />
      { children }
    </Anchor>
  </span>
)

export default CTA